/**
 * Administration contracts (`docs/api.md` §5.4, ADR-15, ADR-16, ADR-26, ADR-27).
 */
/** `GET /admin/access-logs` (`docs/api.md` §5.3, BE-5, ADR-41). */
/**
 * What the activity tracker inside a confidential project may report
 * (`POST /g/<id>/__prisco/events`, ADR-41). Client-reported, so never a data
 * change: those are recorded by the gateway from the project API's answer.
 *
 * `ACTIVITY_HEARTBEAT` is the tracker's own 30-second "still active" signal,
 * the input of the estimated active time (ADR-45). A project app cannot send
 * it itself (`APP_ACTIVITY_ACTIONS`).
 */
export const CLIENT_ACTIVITY_ACTIONS = [
    'PAGE_VIEW',
    'BUTTON_CLICK',
    'FORM_SUBMIT',
    'SEARCH',
    'FILTER',
    'REPORT_EXPORT',
    'DOWNLOAD',
    'ACTIVITY_HEARTBEAT',
];
export const APP_ACTIVITY_ACTIONS = CLIENT_ACTIVITY_ACTIONS.filter((action) => action !== 'ACTIVITY_HEARTBEAT');
/**
 * Every activity the admin log reports.
 *
 * - `PROJECT_OPEN`: `POST /api/projects/:id/access`.
 * - `PROJECT_GATEWAY_OPEN`: a page navigation through the secure gateway
 *   (`/g/<id>/`, ADR-40); the scripts, styles and images a page loads are not logged.
 * - `CLIENT_ACTIVITY_ACTIONS`: reported by the project's activity tracker.
 * - `RECORD_*`: a data-changing call to the project's API through the gateway,
 *   with the result the API actually answered (ADR-41).
 * - `LOGIN`, `LOGOUT`: ProjectHub sign-in events, read from `audit_events`; a
 *   failed sign-in is `LOGIN` with result `DENIED`.
 */
export const ACCESS_LOG_ACTIONS = [
    'PROJECT_OPEN',
    'PROJECT_GATEWAY_OPEN',
    ...CLIENT_ACTIVITY_ACTIONS,
    'RECORD_CREATE',
    'RECORD_UPDATE',
    'RECORD_DELETE',
    'LOGIN',
    'LOGOUT',
];
export const LISTED_ACCESS_LOG_ACTIONS = ACCESS_LOG_ACTIONS.filter((action) => action !== 'ACTIVITY_HEARTBEAT');
/** `FAILED`: allowed, but the operation itself failed (e.g. the project API answered 5xx). */
export const ACCESS_LOG_RESULTS = ['ALLOWED', 'DENIED', 'FAILED'];
/**
 * Who recorded a row: `SERVER` (ProjectHub saw it happen) or `CLIENT` (the
 * activity tracker in the user's browser reported it; untrusted detail).
 */
export const ACCESS_LOG_SOURCES = ['SERVER', 'CLIENT'];
/**
 * Where a row's activity happened: `PRISCO` (ProjectHub itself, or a
 * confidential project through its secure gateway) or `PUBLIC_URL` (a page
 * view on a standard project's own public URL, ADR-47, ADR-48).
 */
export const ACCESS_LOG_CHANNELS = ['PRISCO', 'PUBLIC_URL'];
/**
 * Why the gateway decided as it did (ADR-16 open order). `OPEN_ANY` and
 * `GRANTED` accompany `ALLOWED`; the rest accompany `DENIED`. Admin-only: the
 * caller who was denied only ever sees the generic `PROJECT_ACCESS_DENIED`.
 */
export const ACCESS_LOG_REASONS = [
    'OPEN_ANY',
    'GRANTED',
    'PROJECT_MISSING',
    'PROJECT_ARCHIVED',
    'NOT_GRANTED',
];
//# sourceMappingURL=admin.js.map